/**
* author: duxin
* date: 2020/4/7
* describe: 公司介绍
*/

<template>
	<div class="company">
		<!-- <div class="join-img">
			<div class="bacImg">
				<h1>{{$t('menu.job')}}</h1>
				<a href="#join">
					<span>{{$t('join.find')}}</span>
					<i class="iconfont iconjinru"></i>
				</a>
			</div>
		</div> -->
		<!-- <div class="title-wrap about-me">
			<h2 class="h2 h2-1">{{$t("home.content1")}}</h2>
			<h2 class="h2">{{$t("home.content11")}}</h2>
		</div>
		<div class="desc-wrap">
			<h1 class="p1">
				<span class="title">{{$t("home.content1")}}</span>
			</h1>
			<h4 class="p2"  :class="lang == 'en' ? 'p2-en' : 'p2-zh'">
				{{$t("about.content1")}}
				<br />
				<br />
				{{$t("about.content2")}}
			</h4>
		</div> -->
		<!-- 加入我们 -->
		<!-- <JoinUs></JoinUs> -->
    <!-- 招聘 -->
    <div id="join">
      <Join></Join>
    </div>
		<!-- 联系我们 -->
		<ContactUs></ContactUs>
	</div>
</template>


<script>
import JoinUs from './company-chunks/join-us'
import Join from "./company-chunks/join";
import ContactUs from '../contact/contact-us'

export default {
	name: 'company',
	components: { JoinUs, Join, ContactUs },
	computed: {
		lang() {
			return sessionStorage.getItem('language')
		},
	},
}
</script>

<style lang="less" scoped>
@import "../../style/constant.less";

.company {
	width: 100%;
	margin: 0 auto;
	padding: 100px 0 80px;
}
@media screen and (min-width: 320px) and (max-width: 480px) {
	.company {
		padding: 0px;
	}
}
.title-wrap {
	@media screen and (min-width: 320px) and (max-width: 480px) {
		h1 {
			margin-top: 60px;
		}
		.h2-1 {
			margin: 20px 0;
		}
		h2:last-child {
			margin-bottom: 40px;
		}
	}
}
.desc-wrap {
	display: flex;
	color: @content-color;
	width: @page-width;
	margin: 90px auto 80px;
	background: #fbfbfb url("../../assets/metaBg.png") no-repeat center;

	.title {
		line-height: 1.2em;
		color: @h2-color;
	}
	.p1 {
		position: relative;
		width: 30%;
		padding: 60px 0 60px 60px;
		&::after {
			position: absolute;
			content: " ";
			background-color: #d9d9d9;
			width: 1px;
			top: 60px;
			left: 289px;
			bottom: 60px;
			height: 75%;
		}
	}
	.p2 {
		line-height: 30px;
		width: 70%;
		letter-spacing: 1px;
		white-space: pre-line;
		padding: 60px 60px 60px 0;
	}
	.p2-en {
		text-align: left;
	}
	.p2-zh {
		text-align: justify;
	}
	@media screen and (min-width: 320px) and (max-width: 480px) {
		.p1 {
			padding: 0px;
		}
		.p2 {
			padding: 0px;
		}
	}
}

@media screen and (min-width: 320px) and (max-width: 480px) {
	.title-wrap {
		width: 100%;
		text-align: center;
	}
	.desc-wrap {
		width: 90%;
		padding: 30px 15px 15px 15px;
		flex-direction: column;
		margin: 0 auto;
		.title {
			font-size: 24px;
		}
		img {
			height: 50vh;
		}
		.p1 {
			margin-bottom: 20px;
			&::after {
				content: " ";
				height: 0px;
			}
		}
		.p1,
		.p2 {
			width: 100%;
		}
	}
}
.join-img {
	.bacImg {
		margin: 0 auto;
		width: @page-width;
		height: 400px;
		background: url('../../../src/assets/join_us.png') center center
			no-repeat;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		flex-direction: column;
		h1, a {
			padding-left: 100px;
		}
		a {
			text-decoration: none;
			color: @primary-color;
			display: flex;
			align-items: center;
		}

		.iconjinru {
			font-size: 20px;
			color: @primary-color;

			&:hover {
				cursor: pointer;
			}
		}
	}
}
@media screen and (min-width: 320px) and (max-width: 480px) {
	.join-img {
		.iconjob_offers {
			font-size: 24px;
		}
		.bacImg {
			justify-content: flex-start;
			height: 400px;
			width: 100%;
			background: url('../../../src/assets/join-phone-2.jpg') center center no-repeat;
			.title {
				color: #ffffff;
			}
			h1 {
				padding-top: 50px;
			}
			h1, a {
				padding-left: 50px;
			}
		}
	}
}
</style>
